<template>
    <v-app>
        <driverBar></driverBar>
        <v-main>
            <v-container>
                <!-- The name every stamp today will be recorded under, right
                     after the PIN, so a driver signed in as someone else -- a
                     shared phone, a colleague's PIN -- notices before stamping. -->
                <div v-if="driverName" class="mb-4">
                    <div class="subtitle-1 black--text">สวัสดี คุณ{{ driverName }}</div>
                    <a class="body-2" @click="notMe">ไม่ใช่คุณ? ออกจากระบบ</a>
                </div>
                <div class="title mb-1">เลือกรถของคุณวันนี้</div>
                <div class="body-2 grey--text text--darken-1 mb-4">{{ today }}</div>

                <v-progress-linear v-if="loading" indeterminate color="orange accent-3"></v-progress-linear>

                <v-alert v-if="!loading && !plates.length" type="info" text>
                    วันนี้ไม่มีรถที่มีงานจัดส่ง
                </v-alert>

                <v-card v-for="p in plates" :key="p.regNum" class="mb-3" @click="choose(p.regNum)">
                    <v-card-text class="d-flex align-center">
                        <v-icon size="36" color="orange accent-4" class="mr-3">mdi-truck</v-icon>
                        <div>
                            <div class="title black--text">{{ p.regNum }}</div>
                            <div class="body-2 grey--text text--darken-1">{{ p.stops }} จุดส่ง</div>
                            <div v-if="p.trip" class="body-2 indigo--text">ทริปต่อเนื่อง วันที่ {{ p.trip.dayNo }}/{{ p.trip.days }}</div>
                        </div>
                        <v-spacer></v-spacer>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-card-text>
                </v-card>

                <v-snackbar v-model="showError" color="red" :timeout="4000">{{ error }}</v-snackbar>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
import driverBar from '@/components/driver/driverBar'
import driverService from '@/components/driverService'
export default {
    components: { driverBar },
    data () {
        return {
            plates: [], loading: true, error: '', showError: false,
            driverName: '', loggingOut: false
        }
    },
    computed: {
        today () { return driverService.todayISO() }
    },
    methods: {
        choose (regNum) {
            driverService.storeChosenPlate(regNum)
            this.$router.push({ name: 'driverDay' }).catch(() => {})
        },
        // The same sign-out as driverBar's menu, back to the keypad.
        async notMe () {
            if (this.loggingOut) return
            this.loggingOut = true
            try {
                await driverService.signOutDriver()
                this.$router.push({ name: 'driverPin' }).catch(() => {})
            } finally {
                this.loggingOut = false
            }
        },
        async load () {
            this.loading = true
            try {
                this.plates = await driverService.loadPlates(this.today)
            } catch (e) {
                this.error = 'โหลดรายการรถไม่สำเร็จ กรุณาลองใหม่'
                this.showError = true
            }
            this.loading = false
        }
    },
    mounted () {
        driverService.ensureDriverClaims().then(c => {
            if (!c) return
            this.driverName = c.driverName
        }).catch(() => {})
        this.load()
    }
}
</script>
